import { ROLE_SWITCHED } from "@core/interceptors/request-context";

export interface WriteScope {
  channel: string;
  holds: () => boolean;
}

export const SCOPE_CHANGED =
  "Not sent: the role or channel changed while sending.";
export const SCOPE_CHANGED_REASON =
  "The role or channel changed while sending.";

export function refusedForRoleSwitch(error: unknown): boolean {
  return (
    (error as { statusText?: string } | null)?.statusText === ROLE_SWITCHED
  );
}
